import { render, staticRenderFns } from "./ApplicationFormConfirmChange.vue?vue&type=template&id=20ee5c1e&"
import script from "./ApplicationFormConfirmChange.vue?vue&type=script&lang=ts&"
export * from "./ApplicationFormConfirmChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports